export const slugify = (name) => name.split(" ").join("-");
